import userInfo from "../../function/userInfo";
import i18n from "../../locales/i18n";
import * as API from "../ApiConfig";

export default {
  DoGetAllMainAccount() {
    return API.peakRealTimeAPI
      .post("/api/Account/GetAllAccountByMerchantId", {}, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringAccount() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
    };

    return API.peakReportAPI
      .post("/api/DashBoard/GetMerchantMonitoringAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoSetMerchantMonitoringAccount(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      followingList: followingList,
    };

    return API.peakAPI
      .post("/api/DashBoard/SetMerchantMonitoringAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMerchantMonitoringAccountByAccountIdList(followingList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      date: new Date(),
      language: i18n.locale,
      followingList: followingList,
    };

    return API.peakAPI
      .post("/api/DashBoard/GetMerchantMonitoringAccountByAccountIdList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCreateAccountTemplateOnce(account) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      account: account,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Account/CreateAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateChartOfAccount(account) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      account: account,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Account/UpdateAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetSuggestAccountCode(_accounttypesubid) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accounttypesubid: _accounttypesubid,
    };
    return API.peakRealTimeAPI
      .post("/api/Account/GetSuggestAccountCode", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoUpdateFavoriteAccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: input.accountId,
      favoriteTypeId: input.favoriteTypeId,
    };
    return API.peakAPI.post("/api/Account/UpdateFavoriteAccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoDeleteFavoriteAccount(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: input.accountId,
      financeTypeId: input.financeTypeId,
    };
    return API.peakAPI.post("/api/Account/DeleteFavoriteAccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetFavoriteAccount(financeTypeId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      financeTypeId: financeTypeId,
    };
    return API.peakAPI.post("/api/Account/GetFavoriteAccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetReportForCheckCaptureJournal(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: input.accountId,
      financeTypeId: input.financeTypeId,
    };
    return API.peakRealTimeAPI
      .post("/api/Account/DeleteFavoriteAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetTrialBalanceTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      fromDate: input.fromDate,
      toDate: input.toDate,
      trialBalanceDisplayType: input.trialBalanceDisplayType,
    };
    return API.peakAPI.post("/api/Table/GetTrialBalanceTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetTrialBalanceWithSubAccountTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      fromDate: input.fromDate,
      toDate: input.toDate,
      accountCodeList: input.accountCodeList,
      isUseMainDatabase: true,
      trialBalanceDisplayType: input.trialBalanceDisplayType,
    };
    return API.peakAPI
      .post("/api/Table/GetTrialBalanceWithSubAccountTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMenuGeneralLedgerTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchText: input.searchText,
      toDate: input.toDate,
      fromDate: input.fromDate,
      language: i18n.locale,
    };
    return API.peakAPI.post("/api/Table/GetMenuGeneralLedgerTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetMenuGeneralLedgerWithSubAccountTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchText: input.searchText,
      toDate: input.toDate,
      fromDate: input.fromDate,
      accountCodeList: input.accountCodeList,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Table/GetMenuGeneralLedgerWithSubAccountTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetGeneralLedgerTransactionTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      fromDate: input.fromDate,
      toDate: input.toDate,
      accountId: input.accountId,
      referenceId: input.referenceId,
      referenceTypeId: input.referenceTypeId,
      isShowSubAccount: input.isShowSubAccount,
      pageNumber: input.pageNumber,
      pageSize: input.pageSize,
      language: i18n.locale,
    };
    return API.peakAPI
      .post("/api/Table/GetGeneralLedgerTransactionTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetMenuChartOfAccount() {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
    };
    return API.peakAPI.post("/api/Table/GetMenuChartOfAccount", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetAccountDetail(accountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: accountId,
      language: i18n.locale,
    };
    return API.peakRealTimeAPI
      .post("/api/Account/GetAccountDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetChartOfAccountReferenceTableByAccountId(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: input.accountId,
      pageNo: input.pageNo,
      pageSize: input.pageSize,
    };
    return API.peakAPI
      .post("/api/Table/GetChartOfAccountReferenceTableByAccountId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoValidateConfirmDeleteAccount(accountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: accountId,
    };

    return API.peakRealTimeAPI
      .post("/api/Account/ValidateConfirmDeleteAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteChartOfAccount(accountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      accountId: accountId,
    };

    return API.peakRealTimeAPIForTransaction
      .post("/api/Account/DeleteChartOfAccount", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBalanceSheetTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      isCompareData: true,
      isUseMainDatabase: input.isUseMainDatabase,
      searchCriteria: {
        dateList: input.dateList,
        isShowNonActiveAccountGroups: input.isShowNonActiveAccountGroups,
      },
    };

    return API.peakAPI
      .post("/api/Table/GetBalanceSheetCustomTable", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetBalanceSheetTemplate(isUseMainDatabase) {
    let _input = {
      isUseMainDatabase: isUseMainDatabase,
    };

    return API.peakAPI.post("/api/Account/GetBalanceSheetTemplate", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateBalanceSheetTemplate(balanceSheetTemplate) {
    let _input = {
      balanceSheetTemplate: balanceSheetTemplate,
    };

    return API.peakAPI
      .post("/api/Account/CreateBalanceSheetTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteBalanceSheetTemplate() {
    let _input = {};

    return API.peakAPI
      .post("/api/Account/DeleteBalanceSheetTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetProfitLossCustomTable(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      isCompareData: true,
      isUseMainDatabase: input.isUseMainDatabase,
      searchCriteria: {
        dateList: input.dateList,
      },
    };

    return API.peakAPI.post("/api/Table/GetProfitLossCustomTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetProfitLossTemplate(isUseMainDatabase) {
    let _input = {
      isUseMainDatabase: isUseMainDatabase,
    };

    return API.peakAPI.post("/api/Account/GetProfitLossTemplate", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoCreateProfitLossTemplate(profitLossTemplate) {
    let _input = {
      profitLossTemplate: profitLossTemplate,
    };

    return API.peakAPI
      .post("/api/Account/CreateProfitLossTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoDeleteProfitLossTemplate() {
    let _input = {};

    return API.peakAPI
      .post("/api/Account/DeleteProfitLossTemplate", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetCashFlowStatementTable(dateList) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchCriteria: {
        periodList: dateList,
      },
    };

    return API.peakAPI
      .post("/api/Table/GetStatementOfCashflowTransaction", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetDBDEFilingShareCapital(input) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      filingEndDate: input.currentEndDate,
      previousEndDate: input.previousEndDate,
    };

    return API.peakAPI.post("/api/Account/GetDBDEFilingShareCapital", _input, userInfo.SetHeaderService());
  },
  DoGetSubAccountByAccountId(accountId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      language: i18n.locale,
      accountId: accountId,
    };
    return API.peakAPI
      .post("/api/Account/GetSubAccountByAccountId", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetDBDEFilingSuggestNumber(dateTime) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      dateTime: dateTime.ToDateJsonString(),
    };

    return API.peakAPI.post("/api/Account/GetDBDEFilingSuggestNumber", _input, userInfo.SetHeaderService());
  },
  DoExportGeneralLedger(generalLedgerReportSearchCriterialModel) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      timezoneOffset: userInfo.GetTimezoneOffset(),
      language: i18n.locale,
      generalLedgerReportSearchCriterialModel: generalLedgerReportSearchCriterialModel,
    };
    return API.peakReportAPI
      .post("/api/EmailReport/ExportGeneralLedgerForNewPeak", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoGetDBDEFilingTable(searchCriteria) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      searchCriteria: searchCriteria,
    };

    return API.peakAPI.post("/api/Table/GetDBDEFilingTable", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoGetDBDEFilingStatementPeriod(filingStatementPeriod) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      filingStatementPeriod: filingStatementPeriod,
    };

    return API.peakAPI
      .post("/api/Account/GetDBDEFilingStatementPeriod", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },

  DoInsertDBDEFiling(filingCreate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      filingCreate: filingCreate,
    };

    return API.peakAPI.post("/api/Account/InsertDBDEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoGetDBDEFilingDetail(eFilingId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      eFilingId: eFilingId,
    };

    return API.peakAPI.post("/api/Account/GetDBDEFilingDetail", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoDeleteDBDEFiling(eFilingId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      eFilingId: eFilingId,
    };

    return API.peakAPI.post("/api/Account/DeleteDBDEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoUpdateDBDEFiling(filingUpdate) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      filingUpdate: {
        eFilingId: filingUpdate.eFilingId,
        filingRemarks: filingUpdate.information.filingRemarks,
        status: filingUpdate.status,
      },
    };

    return API.peakAPI.post("/api/Account/UpdateDBDEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoAddFileStorageEFiling(file) {
    const requestBody = [{ merchantId: userInfo.MerchantId(), insertFileStorage: file }];

    return Promise.all(
      requestBody.map((request) =>
        API.peakAPI.post("/api/Account/AddFileStorageEFiling", request, userInfo.SetHeaderService()).then((res) => {
          return res;
        })
      )
    );
  },

  DoGetFileStorageEFiling(eFilingId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      eFilingId: eFilingId,
    };

    return API.peakAPI.post("/api/Account/GetFileStorageEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoVoidFileStorageEFiling(voidFileStorage) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      voidFileStorage: {
        id: voidFileStorage.id,
        fileId: voidFileStorage.fileList[0].id,
      },
    };

    return API.peakAPI.post("/api/Account/VoidFileStorageEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoAddCommentEFiling(insertComment) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      insertComment: insertComment,
    };

    return API.peakAPI.post("/api/Account/AddCommentEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoGetCommentEFiling(eFilingId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      eFilingId: eFilingId,
    };

    return API.peakAPI.post("/api/Account/GetCommentEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },

  DoVoidCommentEFiling(voidComment) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      voidComment: voidComment,
    };

    return API.peakAPI.post("/api/Account/VoidCommentEFiling", _input, userInfo.SetHeaderService()).then((res) => {
      return res;
    });
  },
  DoGetWitholdingTaxDetail(whtId) {
    let _input = {
      merchantId: userInfo.MerchantId(),
      whtId: whtId,
    };

    return API.peakRealTimeAPI
      .post("/api/WitholdingTax/GetWitholdingTaxDetail", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetReportForCheckCaptureJournal() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakReportAPI
      .post("/api/WebJobs/GetReportForCheckCaptureJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoCheckAndUpdateJournalAccountDateApproved() {
    let _input = {};
    return API.peakReportAPI
      .post("/api/Journal/CheckAndUpdateJournalAccountDateApproved", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoReCalculateCaptureJournal() {
    let _input = {
      merchantId: userInfo.MerchantId(),
    };
    return API.peakReportAPI
      .post("/api/WebJobs/ReCalculateCaptureJournal", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAllJournalYearMonthList() {
    return API.peakReportAPI
      .post("/api/Journal/GetAllJournalYearMonthList", {}, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetDataFormCheckJournalAllocationErrorList(input) {
    let _input = {
      month: input.month,
      year: input.year,
    };
    return API.peakReportAPI
      .post("/api/Journal/GetDataFormCheckJournalAllocationErrorList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  GetJournalItemForInvestigateList(input) {
    let _input = {
      month: input.month,
      year: input.year,
      isApproved: input.isApproved,
    };
    return API.peakReportAPI
      .post("/api/Journal/GetJournalItemForInvestigateList", _input, userInfo.SetHeaderService())
      .then((res) => {
        return res;
      });
  },
  DoGetAIRecommendedAccountByContact(input) {
    return API.peakRealTimeAPI.post(
      "/api/Invoice/GetAIRecommendedAccountByContact",
      input,
      userInfo.SetHeaderService()
    );
  },
};
